import React from 'react';
import {Link} from "react-router-dom";

export default function EditButton(props) {

    return (
        <Link to={{pathname: props.path}}>
            <button type="button" className="btn btn-sm btn-outline-dark btn-icon-text">
            <i className="icon-doc btn-icon-prepend"></i>Configure</button>
        </Link>
    );
  }